import { useEffect } from "react";
import Button from "./button";

function Modal({
  onClose,
  header,
  showCloseButton = true,
  children,
  size = "w-11/12 sm:w-1/2 max-w-2xl",
  sx = "",
  full = false,
  overflow = "overflow-hidden",
}) {
  const padding = full ? "" : "p-4 sm:p-8";
  const bg = full ? "bg-overlay-strong" : "";

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={header || "Dialog"}
      className={`fixed inset-0 bg-overlay-strong z-50 flex justify-center items-center overflow-y-auto ${sx}`}
    >
      <div className={`bg-surface rounded ${overflow} ${padding} ${size} relative shadow`}>
        <div className="flex">
          {!full && (
            <h3 className="font-bold mb-4 sm:mb-8 text-xl sm:text-2xl text-text-body flex-grow">
              {header}
            </h3>
          )}
          <button
            type="button"
            onClick={onClose}
            aria-label="Stäng"
            className={`absolute top-4 right-4 sm:top-8 sm:right-8 ${bg} rounded z-10 p-1`}
          >
            <svg
              className={`w-6 h-6 ${full ? "text-inverse" : "text-text-body"}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <title>Stäng</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        {children}
        {showCloseButton && (
          <Button onClick={onClose} sx="mt-4 sm:mt-8">
            Stäng
          </Button>
        )}
      </div>
    </div>
  );
}

export default Modal;
